import React from "react";

export const ru = {
    buttons: {
        login: 'Войти',
        register: 'Регистрация',
        logout: 'Выйти',
        signin: 'Войти',
        signup: 'Зарегистрироваться',
        confirm: 'Подтвердить',
        cancel: 'Отменить',
        resetSkills: 'Сбросить статы',
        save: 'Сохранить',
        setEgor: 'aga',
        setName: 'Задать имя',
        resetItems: 'Снять предметы',
        resetTitle: 'Сбросить титул',
        resetDegree: 'Сбросить степень',
        viewStats: 'Показать статы',
        weapons: 'Оружие',
        crystalMA: 'Кристалл магической защиты',
        crystalPA: 'Кристалл физической защиты',
        crystalMD: 'Кристалл магической атаки',
        crystalPD: 'Кристалл физической атаки',
        armors: 'Броня',
        professions: 'Профессии',
        magic: 'Магия',
        other: 'Другое',
        lightSwords: 'Легкие',
        semiSworder: 'Полуторные',
        heavySwords: 'Тяжелые',
        axes: 'Топоры',
        hammers: 'Молоты',
        lightCrossbows: 'Легкие',
        heavyCrossbows: 'Тяжелые',
        helmets: 'Шлемы',
        cuirasses: 'Кирасы',
        shields: 'Щиты',
        gloves: 'Перчатки',
        belts: 'Поясы',
        pants: 'Поножи',
        boots: 'Сапоги',
        greenRobe: 'Зеленые',
        whiteRobe: 'Белые',
        blueRobe: 'Синие',
        redRobe: 'Красные',
        amulets: 'Амулеты',
        rings: 'Кольца',
        bracers: 'Браслеты',
        titleRings: 'Кольца титула',
        degreeRings: 'Кольца степени',
        assassin: 'Ассассин',
        barbarian: 'Варвар',
        blacksmith: 'Кузнец',
        thief: 'Вор',
        archmage: 'Архимаг',
        druid: 'Друид',
        castles: 'Замки',
        inquisitor: 'Инквизитор',
        necromancer: 'Некромант',
        sorcerer: 'Чародей',
        bandier: 'Бандиер',
        crusader: 'Крестоносец',
        steelMaster: 'Мастер стали',
        armorer: 'Оружейник',
        hunter: 'Охотник',
        radiantMantras: 'Светлые',
        direMantras: 'Темные',
        earthPowder: 'Земли',
        airPowder: 'Воздуха',
        waterPowder: 'Воды',
        firePowder: 'Огня',
        crystals: 'Кристаллы',
        premium: 'Премиум',
        eventItems: 'Ивентовые вещи',
        radiantUseless: 'Светлые',
        direUseless: 'Темные',
        private: 'Приватная',
        public: 'Публичная',
        noPrefix: 'Без префикса',
        yourDolls: 'Ваши',
        otherDolls: 'Прочие',
        tableList: 'Таблицы',
        clans: 'Кланы',
        users: 'Игроки',
        createTable: 'Создать',
        table: 'Таблица',
        doll: 'Кукла',
        sortedByLvl: 'Уровню',
        sortedByTime: 'Времени',
        chosen: 'Избранное',
        calculator: 'Калькулятор',
        add: 'Добавить',
        kick: 'Выгнать',
        ban: 'Забанить',
        banned: 'В бане',
        chat: 'Чат',
        recipes: 'Рецепты',
        maps: 'Карты',
        worldMap: 'Карта Мира',
        selectAll: 'Выбрать все',
        unsetAll: 'Снять все',
        dolls: 'Куклы',
        tables: 'Таблицы',
        home: 'Главная',
        stats: 'Статистика',
        elixir: 'Эликсиры',
        defaultDolls: 'Стандартные',
        send: 'Отправить',
        visible: 'Видно',
        invisible: 'Не видно',
        utils: 'Утилиты',
        compare: 'Сравнить',
        items: 'Предметы',
        description: 'Описание'
    },
    texts: {
        registerIs: 'Регистрация',
        registerFor: ' необходима для сохранения и загрузки ваших кукол и таблиц, а также для отправки сообщений в чат',
        dollWithName: 'Кукла с именем ',
        alreadyExists: ' уже существует. Хотите перезаписать существующую ',
        doll: ' куклу?',
        saveDoll: 'Сохранить вашу куклу как ',
        dollsName: 'Имя куклы:',
        extraSlots: 'Дополнительные слоты',
        reset: 'Сбросить:',
        login: 'Логин',
        register: 'Регистрация',
        hello: 'Здравствуйте, ',
        yourDolls: 'Ваши куклы',
        swords: 'Мечи',
        heavyWeapons: 'Тяжелое оружие',
        crossbows: 'Арбалеты',
        armors: 'Броня',
        robes: 'Робы',
        jewerly: 'Бижутерия',
        multy: 'Мульты',
        title: 'Титул',
        sets: 'Наборы',
        degree: 'Степень',
        mantras: 'Мантры',
        powder: 'Порошки',
        castleItems: 'Замковые предметы',
        other: 'Другое',
        noDollsYet: 'Кукол пока нет...',
        noTablesYet: 'Таблиц пока нет...',
        firstTime: 'Все бывает в первый раз!',
        otherMantras: 'Прочие мантры',
        changeName: 'Изменить имя куклы:',
        newName: 'Новое имя куклы: ',
        deleteDoll: 'Удалить вашу ',
        deleteOther: 'Удалить куклу ',
        deleteOtherFromList: ' из этого списка?',
        copied: 'Скопировано',
        level: 'Уровень',
        name: 'Название',
        time: 'Время',
        date: 'Лить',
        dateOf: 'Залили',
        fillDate: 'Дата',
        status: 'Статус',
        fillingLevel: 'Лива',
        sphereTime: 'СВ',
        clan: 'Клан',
        commentary: 'Комментарий',
        editor: 'Редактор',
        yourTables: 'Ваши таблицы',
        toAttack: 'Спад',
        localTime: 'Местное время',
        moscowTime: 'Московское время',
        sortedBy: 'Отсортировано по ',
        red: 'Красный',
        white: 'Белый',
        yellow: 'Желтый',
        blue: 'Синий',
        action: 'Действие',
        fillingCalculator: 'Калькулятор лив',
        fillingTable: 'Таблица лив',
        actionBlue: 'Залит',
        actionYellow: 'Пожелтел',
        actionRed: 'Покраснел',
        wantToChange: 'Вы хотите изменить роль ',
        roleTo: ' на ',
        wantToKick: 'Вы уверены, что хотите выгнать ',
        fromTable: ' из этой таблицы? Пользователь сможет вернуться, используя ссылку для входа в таблицу',
        noProfession: 'Без профессии',
        websiteMade: 'Сайт сделал',
        wantToBan: 'Вы уверены, что хотите забанить ',
        fromTableBan: ' в этой таблице? Пользователь не сможет видеть содержимое таблицы, пока находится в бане',
        listIsEmpty: 'Список пуст',
        wantToDelete: 'Вы хотите удалить таблицу ',
        willBeDeleted: '? Она будет удалена для всех',
        months: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
        community: 'Discord',
        youtube: 'YouTube',
        castle: 'Замок',
        recipes: 'Рецепты',
        cook: 'Варить',
        consumption: 'Потребление',
        class: 'Класс',
        active: 'Активен',
        multiplier: 'Множитель',
        cookingIn: 'Для варки в ',
        furnace: 'печи',
        cauldron: 'котелке',
        maps: 'Карты',
        hyperion: 'Гиперион',
        charon: 'Харон',
        rhodes: 'Родос',
        leon: 'о. Леон',
        ov: 'о. Выбора',
        phoebus: 'Феб',
        pvpDifference: 'Разница PVP',
        chosenRecipes: 'Избранные рецепты',
        noChosenRecipesYet: 'Пока нет избранных рецептов',
        nickname: 'Никнейм',
        noMessages: 'Сообщений нет',
        down: 'Вниз',
        chooseDoll: 'Выберите куклу',
        mainChat: 'Общий чат',
        enterMessage: 'Введите сообщение...',
        connecting: 'Соединение...',
        table: 'Таблица',
        chooseTable: 'Выберите таблицу',
        moscowTimeShort: 'Москва',
        utils: 'Утилиты',
        utilsDolls: 'Сравнение кукол',
        utilsElixirs: 'Калькулятор длительности лив с таблицей',
        utilsExp: 'Калькулятор опыта',
        utilsOverlay: 'Оверлей таблицы',
        utilsDollsBody: <div className="utils-doll__description">
            <div>Не гадайте – сравнивайте!</div>
            <div>Этот раздел позволит вам:</div>
            <div className="utils-doll__description-list">
                <div>- <b>Сравнить</b> HP, Физическую и Магическую защиту двух кукол</div>
                <div>- <b>Рассчитать</b> точный минимальный, средний и максимальный урон, который персонажи нанесут друг по другу, используя игровую формулу урона</div>
                <div>- <b>Определить</b> количество ударов и времени, необходимые для нейтрализации противника, а также шанс на победу</div>
            </div>
            <i>Сделайте осознанный выбор и принесите пользу своему клану!</i>
        </div>,
        utilsCastleCalcBody: <div className="utils-doll__description">
            <div>Не упустите свой замок!</div>
            <div>Этот раздел поможет вам:</div>
            <div className="utils-doll__description-list">
                <div>- <b>Узнать</b>, сколько времени «лива» каждого уровня защищает замок разного уровня </div>
                <div>- <b>Рассчитать</b> точное время, когда ваш замок «пожелтеет», «спадет» и когда его нужно «лить»</div>
                <div>- <b>Спланировать</b> защиту своего замка или атаку на замок противника</div>
            </div>
            <i>Действуйте на опережение и сохраните свои владения!</i>
        </div>,
        utilsExpBody: <div className="utils-doll__description">
            <div>Планируйте свой путь к вершине!</div>
            <div>Этот раздел поможет вам:</div>
            <div className="utils-doll__description-list">
                <div>- <b>Рассчитать</b> точное количество опыта, необходимое для прокачки персонажа от одних уровней до других.</div>
                <div>- <b>Узнать</b>, сколько всего опыта вы накопите к любому уровню титула и степени.</div>
                <div>- <b>Спланировать</b> ваш путь к новым достижениям, точно зная требуемые ресурсы.</div>
            </div>
            <i>Достигайте новых высот с умом!</i>
        </div>,
        utilsOverlayBody: <div className="utils-doll__description">
            <div>Всегда будьте на шаг впереди!</div>
            <div>Этот оверлей поможет вам:</div>
            <div className="utils-doll__description-list">
                <div>- <b>Отслеживать</b> состояние замков и их статус в реальном времени.</div>
                <div>- <b>Получать</b> данные только о самых важных замках.</div>
                <div>- <b>Принимать</b> быстрые и точные решения для захвата или защиты владений, не отрываясь от игры.</div>
            </div>
            <i>Контролируйте каждый момент на поле боя!</i>
        </div>,
        expUtil: 'Калькулятор опыта',
        dollUtil: 'Сравнение кукол',
        elixirUtil: 'Калькулятор и таблица лив',
        pd: 'ФА',
        md: 'МА',
        pa: 'ФЗ',
        ma: 'МЗ',
        hp: 'ХП',
        stats: 'Характеристики',
        damage: 'Урон',
        timeToKill: 'Времени для убийства',
        hitsToKill: 'Ударов для убийства',
        summary: 'Итог',
        chanceToWin: 'Шанс на победу',
        charNumber: 'Персонажей',
        min: 'Минимум',
        avg: 'Средне',
        max: 'Максимум',
        oneShotChance: 'Шанс ваншота',
        welcome: 'Добро пожаловать!',
        players: 'Игроки',
        tableOverlay: 'Оверлей таблицы',
        tableOverlayAttention: <div>
            <span className="text-secondary"><b>Внимание</b></span>: для работы программы нужна версия не ниже v1.2
        </div>,
        tableOverlayCopyToken: <div>Скопировать токен для входа в программу:</div>,
        tableOverlayDownload: <div className="utils-overlay__overlay-row">
            <div>
                Скачать оверлей с GitHub:
            </div>
            <a target="_blank" rel="noreferrer" href="https://github.com/HUSH-dreams/SphereTableOverlay/releases/download/v2.3/SphereTableOverlay-v2.3.rar">SphereTableOverlay-v2.3.rar</a>
        </div>,
        tableOverlayGithub: <div className="utils-overlay__overlay-row column">
            <div>
                Посмотреть проект на GitHub:
            </div>
            <div>
                <a target="_blank" rel="noreferrer" href="https://github.com/HUSH-dreams/SphereTableOverlay">https://github.com/HUSH-dreams/SphereTableOverlay</a>
            </div>
        </div>,
        tableOverlayLightVersion: 'Легкая версия',
        tableOverlayFullVersion: 'Автономная версия',
        tableOverlayRequired: 'необходим .NET 8.0 Desktop Runtime',
        tableOverlayForFullscreen: <div>
            <p>Если вы хотите, чтобы игра, открытая в полноэкранном режиме,
            не сворачивалась при работе с оверлеем, просто добавьте два файла из архива в папку с игрой.
            Они меняют режим отображения игры с полноэкранного на оконный режим без рамок</p>

            <div className="utils-overlay__overlay-row--margin-top"><i>В случае, если возникнут проблемы с игрой - просто удалите эти файлы d3d9.ini и d3d9.dll из папки с игрой</i></div>
        </div>,
        tableOverlayDotnetDesc: <div className="utils-overlay__overlay-row--desc">
            Для проверки наличия необходимого окружения, нужно сделать следующее:
            <ul>
                <li>Нажать&nbsp;<span>Win+R</span></li>
                <li>Написать&nbsp;<span>cmd</span>&nbsp;и нажать&nbsp;<span>ОК</span></li>
                <li>Вставить команду&nbsp;<span>dotnet --list-runtimes</span>&nbsp;и нажать&nbsp;<span>Enter</span>&nbsp;</li>
            </ul>
            Если в выводе есть следующие строки:&nbsp;<span>Microsoft.AspNetCore.App</span><span>Microsoft.NETCore.App</span><span>Microsoft.WindowsDesktop.App</span>&nbsp;с
            версиями от 8.x.х, то вам подходит легкая версия оверлея
        </div>,
        tableOverlayCheckDotnet: 'Проверка наличия .NET 8',
        tableOverlayUtils: 'Полезное',
        tableOverlayDescription: <div className="utils-overlay__overlay-info">
            <h3>Информация об оверлее</h3>
            <p>SphereTableOverlay – это удобное приложение-оверлей для Windows, созданное, чтобы помочь игрокам
                всегда быть в курсе замковой информации без отрыва от игры</p>
            <h4>Что это такое?</h4>
            <p>
                Оверлей представляет собой прозрачное окно с таблицей, которое вы можете разместить поверх игрового клиента.
                Приложение позволяет задать точные размер и положение на экране.
                Это дает вам возможность видеть самую важную информацию о замках в реальном времени, не переключаясь между окнами
            </p>
            <h4>Как это работает?</h4>
            <ul>
                <li><span>Авторизация как на сайте:</span> Оверлей предлагает авторизацию в приложении как на данном сайте -
                    с помощью логина и пароля или с помощью специального токена, который можно скопировать выше
                </li>
                <li><span>Выбор таблицы:</span> После успешного входа в систему, оверлей предлагает выбрать таблицу, из
                    которой вы будете получать данные
                </li>
                <li><span>Автоматическое обновление:</span> Данные в таблице обновляются автоматически при любом изменении
                    в таблице
                </li>
                <li><span>Фильтр:</span> Фильтр с уровнями замков наверху таблицы позволяет выбрать, какие замки будут отслеживаться
                </li>
                <li><span>Сохранение настроек:</span> После выхода из приложения автоматически сохраняются следующие настройки:
                    размер, положение на экране, задний фон, фильтр замков, выбранная таблица
                </li>
                <li><span>Заполнение таблицы:</span> После клика по замку можно обновить информацию о нем в таблице
                </li>
            </ul>
        </div>,
        homeContainerGreeting: <div className="home-container__title"><b>Добро&nbsp;пожаловать&nbsp;</b>&nbsp;на
            сайт&nbsp;по&nbsp;игре <b>&nbsp;Сфера:&nbsp;Мир&nbsp;избранных!</b></div>,
        homeContainerFind: <div className="home-container__title text-secondary bold">Здесь вы найдете:</div>,
        homeContainerDoll: <div>Конструктор куклы персонажа с возможностью сохранения и отправки другим пользователям</div>,
        homeContainerTable: <div>Таблицу для заполнения информации о ливе замков с возможностью добавления пользователей</div>,
        homeContainerRecipes: <div>Список рецептов для варки порошков с возможностью сохранения в избранное</div>,
        homeContainerMaps: <div>Карты Мира, отдельных материков и различных данжей с точным расположением объектов и возможностью выбора слоёв</div>,
        homeContainerStats: <div>Сравнение статистики PVP персонажей и кланов, а также замковую таблицу за выбранные даты. Статистика обновляется каждый день в 12:00 по МСК</div>,
        homeContainerUtils: <div>Утилиту для детального сравнения различных параметров кукол, калькулятор опыта и калькулятор лив с таблицей,
            а также программу-оверлей для доступа к таблице</div>,
        homeContainerHomePage: 'Главная страница',
        homeContainerChangeLog: <div className="home-container__change-list">
            <div className="home-container__title text-secondary bold">Список изменений:</div>
            <div className="home-container__change-body">
                <div className="home-container__date-separator">
                    <div className="home-container__date-line"></div>
                    <div className="home-container__date">14.08.2026</div>
                    <div className="home-container__version">-&nbsp;<i>v7.4.2</i></div>
                    <div className="home-container__date-line"></div>
                </div>
                <div className="home-container__change-section"><b className="text-secondary">Карты</b></div>
                <div className="home-container__change-text__body">
                    <div className="home-container__change-text-row">
                        В раздел Квестовые данжи добавлено ещё 4 карты
                    </div>
                </div>
                <div className="home-container__date-separator">
                    <div className="home-container__date-line"></div>
                    <div className="home-container__date">13.08.2026</div>
                    <div className="home-container__version">-&nbsp;<i>v7.4.1</i></div>
                    <div className="home-container__date-line"></div>
                </div>
                <div className="home-container__change-section"><b className="text-secondary">Карты</b></div>
                <div className="home-container__change-text__body">
                    <div className="home-container__change-text-row">
                        В раздел Квестовые данжи добавлено ещё 3 карты
                    </div>
                </div>
                <div className="home-container__date-separator">
                    <div className="home-container__date-line"></div>
                    <div className="home-container__date">11.08.2026</div>
                    <div className="home-container__version">-&nbsp;<i>v7.4.0</i></div>
                    <div className="home-container__date-line"></div>
                </div>
                <div className="home-container__change-section"><b className="text-secondary">Карты</b></div>
                <div className="home-container__change-text__body">
                    <div className="home-container__change-text-row">
                        Добавлен раздел квестовых данжей в карты
                    </div>
                    <div className="home-container__change-text-row">
                        В раздел Квестовые данжи добавлено по 1 карте каждого типа данжей
                    </div>
                </div>
                <div className="home-container__date-separator">
                    <div className="home-container__date-line"></div>
                    <div className="home-container__date">09.08.2026</div>
                    <div className="home-container__version">-&nbsp;<i>v7.3</i></div>
                    <div className="home-container__date-line"></div>
                </div>
                <div className="home-container__change-section"><b className="text-secondary">Карты</b></div>
                <div className="home-container__change-text__body">
                    <div className="home-container__change-text-row">
                        Добавлена карта кладбища Шипстоуна и Санпула с отображением именных мобов
                    </div>
                    <div className="home-container__change-text-row">
                        Добавлен маршрут на 4 этаж Фебоданжа
                    </div>
                    <div className="home-container__change-text-row">
                        Добавлены маршруты для большинства карт данжей
                    </div>
                    <div className="home-container__change-text-row">
                        Добавлены два 60 имени на карту Родоса
                    </div>
                </div>
                <div className="home-container__date-separator">
                    <div className="home-container__date-line"></div>
                    <div className="home-container__date">03.08.2026</div>
                    <div className="home-container__version">-&nbsp;<i>v7.2</i></div>
                    <div className="home-container__date-line"></div>
                </div>
                <div className="home-container__change-section"><b className="text-secondary">Карты</b></div>
                <div className="home-container__change-text__body">
                    <div className="home-container__change-text-row">
                        Добавлена карта кладбища Бангвиля (2 этаж)
                    </div>
                    <div className="home-container__change-text-row">
                        Добавлен маршрут для некоторых карт данжей
                    </div>
                </div>
                <div className="home-container__date-separator">
                    <div className="home-container__date-line"></div>
                    <div className="home-container__date">02.08.2026</div>
                    <div className="home-container__version">-&nbsp;<i>v7.1</i></div>
                    <div className="home-container__date-line"></div>
                </div>
                <div className="home-container__change-section"><b className="text-secondary">Карты</b></div>
                <div className="home-container__change-text__body">
                    <div className="home-container__change-text-row">
                        Добавлены иконки на некоторые данжи
                    </div>
                    <div className="home-container__change-text-row">
                        Добавлены карты кладбища Бангвиля (1 этаж) и кладбища Торвиля (2 этаж)
                    </div>
                </div>
                <div className="home-container__date-separator">
                    <div className="home-container__date-line"></div>
                    <div className="home-container__date">27.07.2026</div>
                    <div className="home-container__version">-&nbsp;<i>v7.0</i></div>
                    <div className="home-container__date-line"></div>
                </div>
                <div className="home-container__change-section"><b className="text-secondary">Карты</b></div>
                <div className="home-container__change-text__body">
                    <div className="home-container__change-text-row">
                        Добавлены карты некоторых данжей
                    </div>
                </div>
                <div className="home-container__change-section"><b className="text-secondary">Главная</b></div>
                <div className="home-container__change-text__body">
                    <div className="home-container__change-text-row">
                        Добавлена ссылка на YouTube канал
                    </div>
                </div>
                <div className="home-container__date-separator">
                    <div className="home-container__date-line"></div>
                    <div className="home-container__date">10.07.2026</div>
                    <div className="home-container__version">-&nbsp;<i>v6.16</i></div>
                    <div className="home-container__date-line"></div>
                </div>
                <div className="home-container__change-section"><b className="text-secondary">Оверлей</b></div>
                <div className="home-container__change-text__body">
                    <div className="home-container__change-text-row">
                        Добавлена новая версия программы - v3.7. Улучшена производительность, добавлено меню настроек
                    </div>
                </div>
                <div className="home-container__change-section"><b className="text-secondary">Сравнение кукол</b></div>
                <div className="home-container__change-text__body">
                    <div className="home-container__change-text-row">
                        Изменена формула подсчёта урона
                    </div>
                    <div className="home-container__change-text-row">
                        Добавлен шанс на ваншот
                    </div>
                </div>
                <div className="home-container__date-separator">
                    <div className="home-container__date-line"></div>
                    <div className="home-container__date">05.10.2025</div>
                    <div className="home-container__version">-&nbsp;<i>v6.15</i></div>
                    <div className="home-container__date-line"></div>
                </div>
                <div className="home-container__change-section"><b className="text-secondary">Оверлей</b></div>
                <div className="home-container__change-text__body">
                    <div className="home-container__change-text-row">
                        Добавлена новая версия программы - v2.5. Исправлены баги с сортировкой замков. Добавлена сортировка
                        по уровню замков
                    </div>
                </div>
                <div className="home-container__change-section"><b className="text-secondary">Кукла</b></div>
                <div className="home-container__change-text__body">
                    <div className="home-container__change-text-row">
                        Исправлены/добавлены некоторые анимации
                    </div>
                </div>
                <div className="home-container__date-separator">
                    <div className="home-container__date-line"></div>
                    <div className="home-container__date">28.09.2025</div>
                    <div className="home-container__version">-&nbsp;<i>v6.14</i></div>
                    <div className="home-container__date-line"></div>
                </div>
                <div className="home-container__change-section"><b className="text-secondary">Оверлей</b></div>
                <div className="home-container__change-text__body">
                    <div className="home-container__change-text-row">
                        Добавлена новая версия программы - v2.4. Добавлены колонки Комментарий и Лить в таблице. Также
                        добавлена возможность свернуть контент приложения и снять/выбрать все замки
                    </div>
                </div>
                <div className="home-container__date-separator">
                    <div className="home-container__date-line"></div>
                    <div className="home-container__date">09.09.2025</div>
                    <div className="home-container__version">-&nbsp;<i>v6.13</i></div>
                    <div className="home-container__date-line"></div>
                </div>
                <div className="home-container__change-section"><b className="text-secondary">Таблица</b></div>
                <div className="home-container__change-text__body">
                    <div className="home-container__change-text-row">
                        Добавлена подстановка текущего времени в окне редактирования замка
                    </div>
                </div>
                <div className="home-container__change-section"><b className="text-secondary">Оверлей</b></div>
                <div className="home-container__change-text__body">
                    <div className="home-container__change-text-row">
                        Добавлена новая версия программы - v2.3. Убрано отображение лишних элементов интерфейса,
                        а также в окне редактирования замка выставляется текущее время
                    </div>
                </div>
                <div className="home-container__change-section"><b className="text-secondary">Сайт</b></div>
                <div className="home-container__change-text__body">
                    <div className="home-container__change-text-row">
                        Исправлена ошибка со счётчиком гостей
                    </div>
                </div>
                <div className="home-container__date-separator">
                    <div className="home-container__date-line"></div>
                    <div className="home-container__date">08.09.2025</div>
                    <div className="home-container__version">-&nbsp;<i>v6.12</i></div>
                    <div className="home-container__date-line"></div>
                </div>
                <div className="home-container__change-section"><b className="text-secondary">Таблица</b></div>
                <div className="home-container__change-text__body">
                    <div className="home-container__change-text-row">
                        Добавлена возможность выбрать свой клан. Для этого нажмите на название вашего клана в списке кланов таблицы
                    </div>
                    <div className="home-container__change-text-row">
                        Поле статуса перенесено в левую часть таблицы
                    </div>
                </div>
                <div className="home-container__change-section"><b className="text-secondary">Оверлей</b></div>
                <div className="home-container__change-text__body">
                    <div className="home-container__change-text-row">
                        Добавлена новая версия программы - v2.2. В ней появились колонки Спад (время до спада) и Клан,
                        а также возможность менять порядок колонок
                    </div>
                </div>
                <div className="home-container__date-separator">
                    <div className="home-container__date-line"></div>
                    <div className="home-container__date">07.09.2025</div>
                    <div className="home-container__version">-&nbsp;<i>v6.11</i></div>
                    <div className="home-container__date-line"></div>
                </div>
                <div className="home-container__change-section"><b className="text-secondary">Оверлей</b></div>
                <div className="home-container__change-text__body">
                    <div className="home-container__change-text-row">
                        Добавлена новая версия программы - v2.1. В новой версии добавлен индикатор первоначальной загрузки,
                        а также исправлено отображение оверлея поверх игры
                    </div>
                </div>
                <div className="home-container__change-text">
                    <div className="home-container__change-section"><b className="text-secondary">Калькулятор</b></div>
                    <div className="home-container__change-text__body">
                        <div className="home-container__change-text-row">
                            Исправлен баг с уровнями ливы
                        </div>
                        <div className="home-container__change-text-row">
                            Изменено положение кнопки закрытия калькулятора в таблице
                        </div>
                    </div>
                </div>
                <div className="home-container__date-separator">
                    <div className="home-container__date-line"></div>
                    <div className="home-container__date">01.09.2025</div>
                    <div className="home-container__version">-&nbsp;<i>v6.10</i></div>
                    <div className="home-container__date-line"></div>
                </div>
                <div className="home-container__change-text">
                    <div className="home-container__change-section"><b className="text-secondary">Кукла</b></div>
                    <div className="home-container__change-text__body">
                        <div className="home-container__change-text-row">
                            Дополнен список замковых предметов для 15-45 замков
                        </div>
                    </div>
                </div>
                <div className="home-container__change-text">
                    <div className="home-container__change-section"><b className="text-secondary">Сайт</b></div>
                    <div className="home-container__change-text__body">
                        <div className="home-container__change-text-row">
                            Переведен весь основной контент сайта на английский язык
                        </div>
                    </div>
                </div>
                <div className="home-container__date-separator">
                    <div className="home-container__date-line"></div>
                    <div className="home-container__date">31.08.2025</div>
                    <div className="home-container__version">-&nbsp;<i>v6.9</i></div>
                    <div className="home-container__date-line"></div>
                </div>
                <div className="home-container__change-text">
                    <div className="home-container__change-section"><b className="text-secondary">Кукла</b></div>
                    <div className="home-container__change-text__body">
                        <div className="home-container__change-text-row">
                            Замковые предметы теперь сгруппированы по отдельным замкам и имеют правильный префикс
                        </div>
                    </div>
                </div>
                <div className="home-container__date-separator">
                    <div className="home-container__date-line"></div>
                    <div className="home-container__date">30.08.2025</div>
                    <div className="home-container__version">-&nbsp;<i>v6.8</i></div>
                    <div className="home-container__date-line"></div>
                </div>
                <div className="home-container__change-text">
                    <div className="home-container__change-section"><b className="text-secondary">Оверлей</b></div>
                    <div className="home-container__change-text__body">
                        <div className="home-container__change-text-row">
                            Добавлена новая версия программы - v2.0. В новой версии можно заполнять информацию о замках
                        </div>
                    </div>
                </div>
                <div className="home-container__change-text">
                    <div className="home-container__change-section"><b className="text-secondary">Таблица</b></div>
                    <div className="home-container__change-text__body">
                        <div className="home-container__change-text-row">
                            Изменено поведение сайта, если таблица была выбрана. Теперь изменения, внесенные другим
                            пользователем, будет видно в любом разделе сайта. Также при переходе с другого раздела
                            в на страницу с таблицей, не придется заново выбирать таблицу
                        </div>
                        <div className="home-container__change-text-row">
                            Улучшено отображение таблицы на узких экранах
                        </div>
                    </div>
                </div>
                <div className="home-container__date-separator">
                    <div className="home-container__date-line"></div>
                    <div className="home-container__date">29.08.2025</div>
                    <div className="home-container__version">-&nbsp;<i>v6.7</i></div>
                    <div className="home-container__date-line"></div>
                </div>
                <div className="home-container__change-text">
                    <div className="home-container__change-section"><b className="text-secondary">Оверлей</b></div>
                    <div className="home-container__change-text__body">
                        <div className="home-container__change-text-row">
                            Добавлена новая версия программы - v1.2
                        </div>
                        <div className="home-container__change-text-row">
                            Добавлены мобильные стили для раздела с оверлеем
                        </div>
                    </div>
                </div>
                <div className="home-container__change-text">
                    <div className="home-container__change-section"><b className="text-secondary">Таблица</b></div>
                    <div className="home-container__change-text__body">
                        <div className="home-container__change-text-row">
                            Переделан механизм работы таблицы с сервером - теперь все действия в таблице
                            (добавление/удаление кланов, пользователей, изменение данных замков) видны сразу
                            всем онлайн пользователям таблицы без перезахода
                        </div>
                    </div>
                </div>
                <div className="home-container__date-separator">
                    <div className="home-container__date-line"></div>
                    <div className="home-container__date">27.08.2025</div>
                    <div className="home-container__version">-&nbsp;<i>v6.6</i></div>
                    <div className="home-container__date-line"></div>
                </div>
                <div className="home-container__change-text">
                    <div className="home-container__change-section"><b className="text-secondary">Оверлей</b></div>
                    <div className="home-container__change-text__body">
                        <div className="home-container__change-text-row">
                            Добавлена новая утилита - программа-оверлей, позволяющая получить доступ к таблице поверх
                            игрового окна, без открытого браузера
                        </div>
                        <div className="home-container__change-text-row">
                            Добавлена ссылка на новую версию оверлея
                        </div>
                    </div>
                </div>
                <div className="home-container__date-separator">
                    <div className="home-container__date-line"></div>
                    <div className="home-container__date">24.08.2025</div>
                    <div className="home-container__version">-&nbsp;<i>v6.5</i></div>
                    <div className="home-container__date-line"></div>
                </div>
                <div className="home-container__change-text">
                    <div className="home-container__change-section"><b className="text-secondary">Кукла</b></div>
                    <div className="home-container__change-text__body">
                        <div className="home-container__change-text-row">
                            Добавлены наборы брони и бижутерии в список предметов
                        </div>
                        <div className="home-container__change-text-row">
                            Незначительные улучшения визуала
                        </div>
                    </div>
                </div>
                <div className="home-container__change-text">
                    <div className="home-container__change-section"><b className="text-secondary">Сайт</b></div>
                    <div className="home-container__change-text__body">
                        <div className="home-container__change-text-row">
                            Фикс минорных багов
                        </div>
                    </div>
                </div>
                <div className="home-container__date-separator">
                    <div className="home-container__date-line"></div>
                    <div className="home-container__date">23.08.2025</div>
                    <div className="home-container__version">-&nbsp;<i>v6.4</i></div>
                    <div className="home-container__date-line"></div>
                </div>
                <div className="home-container__change-text">
                    <div className="home-container__change-section"><b className="text-secondary">Статистика</b></div>
                    <div className="home-container__change-text__body">
                        <div className="home-container__change-text-row">
                            Добавлена возможность посмотреть статистику замков и клановое пвп
                        </div>
                    </div>
                </div>
                <div className="home-container__change-text">
                    <div className="home-container__change-section"><b className="text-secondary">Чат</b></div>
                    <div className="home-container__change-text__body">
                        <div className="home-container__change-text-row">
                            На мобильных устройствах чат теперь всегда находится справа
                        </div>
                    </div>
                </div>
                <div className="home-container__change-text">
                    <div className="home-container__change-section"><b className="text-secondary">Улучшения</b></div>
                    <div className="home-container__change-text__body">
                        <div className="home-container__change-text-row">
                            Незначительные улучшения визуала
                        </div>
                        <div className="home-container__change-text-row">
                            Изменен стиль калькулятора лив и разницы пвп
                        </div>
                        <div className="home-container__change-text-row">
                            Оптимизация для мобильных устройств
                        </div>
                    </div>
                </div>
                <div className="home-container__date-separator">
                    <div className="home-container__date-line"></div>
                    <div className="home-container__date">22.08.2025</div>
                    <div className="home-container__version">-&nbsp;<i>v6.3</i></div>
                    <div className="home-container__date-line"></div>
                </div>
                <div className="home-container__change-text">
                    <div className="home-container__change-section"><b className="text-secondary">Меню</b></div>
                    <div className="home-container__change-text__body">
                        <div className="home-container__change-text-row">
                            Меню на мобильных устройствах теперь не видно постоянно, но доступно по кнопке
                        </div>
                    </div>
                </div>
                <div className="home-container__change-text">
                    <div className="home-container__change-section"><b className="text-secondary">Карты</b></div>
                    <div className="home-container__change-text__body">
                        <div className="home-container__change-text-row">
                            Добавлена карта Острова Выбора
                        </div>
                    </div>
                </div>
                <div className="home-container__date-separator">
                    <div className="home-container__date-line"></div>
                    <div className="home-container__date">22.08.2025</div>
                    <div className="home-container__version">-&nbsp;<i>v6.2</i></div>
                    <div className="home-container__date-line"></div>
                </div>
                <div className="home-container__change-text">
                    <div className="home-container__change-section"><b className="text-secondary">Калькулятор опыта</b></div>
                    <div className="home-container__change-text__body">
                        <div className="home-container__change-text-row">
                            Добавлена новая утилита - калькулятор опыта. Калькулятор позволяет получить информацию о том, сколько
                            опыта нужно для прокачки персонажа от и до конкретных уровней
                        </div>
                    </div>
                </div>
                <div className="home-container__change-text">
                    <div className="home-container__change-section"><b className="text-secondary">Карты</b></div>
                    <div className="home-container__change-text__body">
                        <div className="home-container__change-text-row">
                            Добавлена карта острова Леон (замок Иль-Суильи-Руа)
                        </div>
                        <div className="home-container__change-text-row">
                            Добавлены иконки спауна Демонов стихий на Гиперионе
                        </div>
                        <div className="home-container__change-text-row">
                            Исправлен баг со смещенными иконками на картах
                        </div>
                    </div>
                </div>
                <div className="home-container__change-text">
                    <div className="home-container__change-section"><b className="text-secondary">Статистика</b></div>
                    <div className="home-container__change-text__body">
                        <div className="home-container__change-text-row">
                            В раздел статистики добавлены двойные стрелки, позволяющие перематывать статистику на месяц вперед или назад
                        </div>
                    </div>
                </div>
                <div className="home-container__change-text">
                    <div className="home-container__change-section"><b className="text-secondary">Сравнение кукол</b></div>
                    <div className="home-container__change-text__body">
                        <div className="home-container__change-text-row">
                            Откорректирована формула урона
                        </div>
                    </div>
                    <div className="home-container__change-text__body">
                        <div className="home-container__change-text-row">
                            Добавлена возможность сравнивать чужие и стандартные куклы
                        </div>
                    </div>
                </div>
                <div className="home-container__change-text">
                    <div className="home-container__change-section"><b className="text-secondary">Чат</b></div>
                    <div className="home-container__change-text__body">
                        <div className="home-container__change-text-row">
                            Исправлен баг с порядком сообщений в чате на некоторых устройствах
                        </div>
                    </div>
                </div>
                <div className="home-container__date-separator">
                    <div className="home-container__date-line"></div>
                    <div className="home-container__date">20.08.2025</div>
                    <div className="home-container__version">-&nbsp;<i>v6.1</i></div>
                    <div className="home-container__date-line"></div>
                </div>
                <div className="home-container__change-text">
                    <div className="home-container__change-section"><b className="text-secondary">Утилиты</b></div>
                    <div className="home-container__change-text__body">
                        <div className="home-container__change-text-row">
                            Добавлены стили для средних и маленьких экранов
                        </div>
                    </div>
                </div>
                <div className="home-container__date-separator">
                    <div className="home-container__date-line"></div>
                    <div className="home-container__date">20.08.2025</div>
                    <div className="home-container__version">-&nbsp;<i>v6.0</i></div>
                    <div className="home-container__date-line"></div>
                </div>
                <div className="home-container__change-text">
                    <div className="home-container__change-section"><b className="text-secondary">Сравнение кукол</b></div>
                    <div className="home-container__change-text__body">
                        <div className="home-container__change-text-row">
                            Добавлена новая утилита - "Сравнение кукол". Данная утилита позволяет детально
                            сравнить две куклы и узнать, сколько времени и ударов нужно для убийства, какой урон
                            может нанести персонаж и какой шанс на победу
                        </div>
                    </div>
                    <div className="home-container__change-section"><b className="text-secondary">Утилиты</b></div>
                    <div className="home-container__change-text__body">
                        <div className="home-container__change-text-row">
                            Новый раздел сайта. На данный момент в нем можно найти утилиты "Сравнение кукол" и
                            "Калькулятор лив"
                        </div>
                    </div>
                    <div className="home-container__change-section"><b className="text-secondary">Кукла</b></div>
                    <div className="home-container__change-text__body">
                        <div className="home-container__change-text-row">
                            Убраны лишние пустые контейнеры для предметов
                        </div>
                    </div>
                </div>
                <div className="home-container__date-separator">
                    <div className="home-container__date-line"></div>
                    <div className="home-container__date">23.07.2025</div>
                    <div className="home-container__version">-&nbsp;<i>v5.6</i></div>
                    <div className="home-container__date-line"></div>
                </div>
                <div className="home-container__change-text">
                    <div className="home-container__change-section"><b className="text-secondary">Таблица</b></div>
                    <div className="home-container__change-text__body">
                        <div className="home-container__change-text-row">
                            Исправлена ошибка с закрытием окна редактирования замка при нажатии на него
                        </div>
                    </div>
                </div>
                <div className="home-container__date-separator">
                    <div className="home-container__date-line"></div>
                    <div className="home-container__date">21.07.2025</div>
                    <div className="home-container__version">-&nbsp;<i>v5.5</i></div>
                    <div className="home-container__date-line"></div>
                </div>
                <div className="home-container__change-text">
                    <div className="home-container__change-section"><b className="text-secondary">Аккаунт</b></div>
                    <div className="home-container__change-text__body">
                        <div className="home-container__change-text-row">
                            В боковое меню добавлен переключатель видимости (по умолчанию - виден). Переключатель влияет
                            на отображение никнейма в списке онлайн пользователей
                        </div>
                    </div>
                    <div className="home-container__change-section"><b className="text-secondary">Таблица</b></div>
                    <div className="home-container__change-text__body">
                        <div className="home-container__change-text-row">
                            Исправлен баг с открытием нескольких окошек редактирования замков
                        </div>
                    </div>
                    <div className="home-container__change-section"><b className="text-secondary">Рецепты</b></div>
                    <div className="home-container__change-text__body">
                        <div className="home-container__change-text-row">
                            Изменен порядок профессий
                        </div>
                    </div>
                    <div className="home-container__change-section"><b className="text-secondary">Улучшения</b></div>
                    <div className="home-container__change-text__body">
                        <div className="home-container__change-text-row">
                            Незначительные улучшения отображения и анимаций элементов
                        </div>
                    </div>
                </div>
                <div className="home-container__date-separator">
                    <div className="home-container__date-line"></div>
                    <div className="home-container__date">20.07.2025</div>
                    <div className="home-container__version">-&nbsp;<i>v5.4</i></div>
                    <div className="home-container__date-line"></div>
                </div>
                <div className="home-container__change-text">
                    <div className="home-container__change-section"><b className="text-secondary">Улучшения</b></div>
                    <div className="home-container__change-text__body">
                        <div className="home-container__change-text-row">
                            Незначительные улучшения визуала
                        </div>
                    </div>
                    <div className="home-container__change-section"><b className="text-secondary">Таблица</b></div>
                    <div className="home-container__change-text__body">
                        <div className="home-container__change-text-row">
                            Изменено отображение таблицы на мобильных устройствах - теперь отображаются только самые важные поля таблицы
                        </div>
                    </div>
                </div>
                <div className="home-container__date-separator">
                    <div className="home-container__date-line"></div>
                    <div className="home-container__date">19.07.2025</div>
                    <div className="home-container__version">-&nbsp;<i>v5.3</i></div>
                    <div className="home-container__date-line"></div>
                </div>
                <div className="home-container__change-text">
                    <div className="home-container__change-section"><b className="text-secondary">Улучшения</b></div>
                    <div className="home-container__change-text__body">
                        <div className="home-container__change-text-row">
                            Переделана логика перехода по страницам на мобильных устройствах: теперь при переходе
                            на другую страницу на экране появляется сам контент страницы, а не боковое меню.
                            Такое же поведение добавлено и для выбора куклы или таблицы
                        </div>
                        <div className="home-container__change-text-row">
                            Незначительные улучшения визуала
                        </div>
                    </div>
                </div>
                <div className="home-container__change-text">
                    <div className="home-container__change-section"><b className="text-secondary">Исправления</b></div>
                    <div className="home-container__change-text__body">
                        <div className="home-container__change-text-row">
                            Исправлен механизм подгрузки выбранной куклы
                        </div>
                        <div className="home-container__change-text-row">
                            Исправлены проблемы с отображением сайта для браузеров Mozilla Firefox и Safari
                        </div>
                        <div className="home-container__change-text-row">
                            Исправлен баг с отображением пустых уведомлений
                        </div>
                    </div>
                </div>

                <div className="home-container__date-separator">
                    <div className="home-container__date-line"></div>
                    <div className="home-container__date">18.07.2025</div>
                    <div className="home-container__version">-&nbsp;<i>v5.2</i></div>
                    <div className="home-container__date-line"></div>
                </div>
                <div className="home-container__change-text">
                    <div className="home-container__change-section"><b className="text-secondary">Статистика</b></div>
                    <div className="home-container__change-text__body">
                        <div className="home-container__change-text-row">
                            Добавлена колонка кланов в окошко с разницей PVP очков
                        </div>
                        <div className="home-container__change-text-row">
                            Изменение стилей статистики на мобильных устройствах
                        </div>
                    </div>
                    <div className="home-container__change-section"><b className="text-secondary">Таблица</b></div>
                    <div className="home-container__change-text__body">
                        <div className="home-container__change-text-row">
                            Изменен внешний вид страницы когда таблица не выбрана
                        </div>
                        <div className="home-container__change-text-row">
                            Калькулятор лив теперь доступен без выбора таблицы
                        </div>
                    </div>
                    <div className="home-container__change-section"><b className="text-secondary">Исправления</b></div>
                    <div className="home-container__change-text__body">
                        <div className="home-container__change-text-row">
                            Исправлены незначительные баги отображения
                        </div>
                        <div className="home-container__change-text-row">
                            Исправлен баг с 8 дополнительным слотом в кукле
                        </div>
                        <div className="home-container__change-text-row">
                            Добавлена возможность выбора стандартной куклы для неавторизованных пользователей
                        </div>
                    </div>
                </div>

                <div className="home-container__date-separator">
                    <div className="home-container__date-line"></div>
                    <div className="home-container__date">17.07.2025</div>
                    <div className="home-container__version">-&nbsp;<i>v5.1</i></div>
                    <div className="home-container__date-line"></div>
                </div>
                <div className="home-container__change-text">
                    <div className="home-container__change-section"><b className="text-secondary">Кукла</b></div>
                    <div className="home-container__change-text__body">
                        <div className="home-container__change-text-row">
                            Добавлен список стандартных кукол в левом боковом меню
                        </div>
                        <div className="home-container__change-text-row">
                            Добавлена фильтрация кукол по профессиям
                        </div>
                    </div>
                </div>
                <div className="home-container__change-text">
                    <div className="home-container__change-section"><b className="text-secondary">Статистика</b></div>
                    <div className="home-container__change-text__body">
                        <div className="home-container__change-text-row">Изменено расположение статистики при заходе
                            на страницу. Теперь статистика за наиболее "свежую" дату находится справа, а за
                            предыдущую - слева
                        </div>
                    </div>
                </div>
                <div className="home-container__change-text">
                    <div className="home-container__change-section"><b className="text-secondary">Таблица</b></div>
                    <div className="home-container__change-text__body">
                        <div className="home-container__change-text-row">Теперь нельзя открыть окошко изменения
                            замка, если список кланов в таблице пуст - добавлено всплывающее уведомление
                        </div>
                        <div className="home-container__change-text-row">"Избранное" теперь является стандартным
                            списком замков в таблице
                        </div>
                    </div>
                </div>
                <div className="home-container__change-text">
                    <div className="home-container__change-section"><b className="text-secondary">Рецепты</b></div>
                    <div className="home-container__change-text__body">
                        <div className="home-container__change-text-row">Список избранных рецептов теперь виден и
                            неавторизованным пользователям
                        </div>
                    </div>
                </div>
                <div className="home-container__change-text">
                    <div className="home-container__change-section"><b className="text-secondary">Чат</b></div>
                    <div className="home-container__change-text__body">
                        <div className="home-container__change-text-row">Убрана прокрутка чата к последнему сообщению при переходе по страницам
                        </div>
                    </div>
                </div>
            </div>
        </div>,
        homeContainerNewSections: <i>* Возможно добавление других разделов в будущем</i>,
        homeContainerOnline: 'Сейчас на сайте:',
        homeContainerGuests: 'Гостей:',
        utilsExpStartLvl: 'Начальный уровень',
        utilsExpEndLvl: 'Конечный уровень',
        utilsExpRequired: 'Необходимое количество опыта',
        utilsExpDescription: <div className="util-exp__desc">
            <p>Калькулятор рассчитывает минимальное количество опыта, необходимое для апа указанных
                уровней</p>
            <p>Правильная прокачка подразумевает, что титул и степень персонажа никогда не будут отличаться
                больше, чем на единицу, или стремятся к этому. </p>
            <p>Пример: прокачка с 10/20 до 50/40.
                Калькулятор сначала уравнивает уровни
                (получается 20/20), затем прокачивает до 40/40 (20/21, 21/21, 21/22 и т.д.), и только после этого
                докачивает титул до 50</p>
        </div>
    },
    errors: {
        emailRegex: 'Неправильный формат почты',
        passwordRegex: 'Минимум 8 символов, как минимум 1 заглавная буква, 1 строчная буква и 1 цифра',
        confirmPassword: 'Пароли не совпадают',
        nickname: 'Никнейм должен быть между 4 и 24 символами'
    },
    inputs: {
        email: 'Почта',
        nickname: 'Никнейм',
        password: 'Пароль',
        confirmPassword: 'Подтвердить пароль',
        name: 'Имя',
        newTable: 'Таблица лучшего клана...'
    },
    selects: {
        select1: 'Обычный',
        select2: 'Великий',
        select3: 'Величайший',
        select4: 'Легендарный',
        today: 'Сегодня',
        yesterday: 'Вчера',
        twoDaysAgo: 'Позавчера',
        tomorrow: 'Завтра',
        earlier: 'Давно',
        moderator: 'Модератор',
        viewer: 'Зритель',
    },
}